import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { InfiniteScrollStore } from '../../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { routeParams } from '../../../../../shared/shared.global-service';
import { getAddressFrag } from './select-folder-address-dialog.query';

@Injectable()
export class SelectFolderAddressDialogStore extends ComponentStoreV2Factory {

    public addressScroll = computed(() => {
        const filter = new FilterBuilder();
        filter
            .folderId(routeParams.folderId())
            .date(new Date(), 'validFrom')
        ;

        return new InfiniteScrollStore(
            this.api.getPersonAddresses,
            filter.singlePage(),
            true,
            getAddressFrag,
            undefined,
            true,
        );
    });

}
